<template>
  <div>
    <QuotationSelectedCompany @return="previousStep" :form="readonlyForm" />
    <QuotationInsuredForm
      @submit="submit"
      @cancel="cancelQuotationButton"
      v-model="formInsured"
      :options-quotation="optionsQuotation"
    />
  </div>
</template>
<script>
import QuotationSelectedCompany from "../components/QuotationSelectedCompany";
import QuotationInsuredForm from "../components/QuotationInsuredForm";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";
export default {
  name: "QuotationStepInsured",
  data: () => ({
    formInsured: {}
  }),
  components: {
    QuotationSelectedCompany,
    QuotationInsuredForm
  },
  mixins: [QuotationMixin],
  computed: {
    nextQuotationStep() {
      return {
        name: "quotation step select resource",
        step: 3
      };
    },
    nextQuotationWithoutRecursalStep() {
      return {
        name: "quotation step resource without recursal",
        step: 3
      };
    },
    previousQuotationStep() {
      return {
        name: "quotation step company",
        step: 2
      };
    }
  },
  created() {
    this.formInsured = { ...this.form };
  },
  methods: {
    submit(form) {
      // Hoje se a modalidade tiver recursos, devo utilizar this.nextQuotationStep,
      // se não this.nextQuotationWithoutRecursalStep, porém futuramente,
      // pode ter modalidades que mesclam composicao_importancia_segurada, recursos
      // e valor_importancia_segurada, nestes casos, a regra mudará.
      let nextStep = this.optionsQuotation.recursos.obrigatorio
        ? this.nextQuotationStep
        : this.nextQuotationWithoutRecursalStep;
      this.$emit("updateStep", this.payloadQuotation(form, nextStep));
    },
    previousStep() {
      this.$emit(
        "updateStep",
        this.payloadQuotation(this.formInsured, this.previousQuotationStep)
      );
    }
  },
  props: {
    form: {
      type: Object
    },
    readonlyForm: {
      type: Object
    },
    optionsQuotation: {
      type: Object
    }
  }
};
</script>
<style lang="sass"></style>
